import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Notification } from "../../../components/GenericActions";
import invoiceListService from "./invoiceList.service";

const initialState = {
  invoiceListData: [],
  isError: false,
  isSuccess: false,
  isLoading: false,
  statusMessage: "",
};

export const getAllInvoice = createAsyncThunk(
  "invoice/getList",
  async (finalData, thunkAPI) => {
    try {
      const response = await invoiceListService.getAllInvoice(finalData);
      if (response.succeeded === true) {
        // Notification(response.message, response.succeeded);
        return response;
      }
    } catch (error) {
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      Notification(message, false);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

const invoiceListSlice = createSlice({
  name: "invoiceList",
  initialState,
  reducers: {
    clearData: (state) => {
      state.isLoading = false;
      state.isSuccess = false;
      state.isError = false;
      state.statusMessage = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getAllInvoice.pending, (state) => {
        state.isLoading = true;
        state.invoiceListData = [];
      })
      .addCase(getAllInvoice.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.invoiceListData = action.payload.data;
      })
      .addCase(getAllInvoice.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.statusMessage = action.payload;
      });
  },
});
export const { clearData } = invoiceListSlice.actions;

export default invoiceListSlice.reducer;
